module.exports = __webpack_public_path__ + "static/scale-model-of-usps-annex-in-fargo-north-dakota-4b537f6c4d7f13366d460210261ba84d.png";